// src/components/ui/Modal.js
import React from 'react';
import { X } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

const Modal = ({ isOpen, onClose, title, children, maxWidthClass = 'max-w-md' }) => {
  const { theme } = useAppContext();

  if (!isOpen) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className={`w-full ${maxWidthClass} p-6 rounded-2xl border transition-colors ${theme === 'dark' ? 'bg-black border-gray-800 text-white' : 'bg-white border-gray-200 text-black'}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold">{title}</h2>
          <button 
            onClick={onClose} 
            className={`p-1 rounded-full transition-colors ${theme === 'dark' ? 'hover:bg-gray-800' : 'hover:bg-gray-200'}`}
          >
            <X size={20} />
          </button>
        </div>

        <div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
